function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fontSize: 22,
    viewBox: "0 0 200 200"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m147.1 93.9 1-.9c3.3-3 5.2-7.3 5.2-11.7V62.5c0-8.7-7.1-15.8-15.8-15.8h-75c-8.7 0-15.8 7.1-15.8 15.8v18.8c0 4.5 1.9 8.8 5.3 11.7l1 .9v49.9c0 5.2 4.3 9.5 9.5 9.5h75c5.2 0 9.5-4.3 9.5-9.5V93.9zm-37.8 52.9H90.9V122h18.5v24.8zm31.3 0h-24.8v-28c0-1.8-1.5-3.2-3.2-3.2h-25c-1.8 0-3.2 1.5-3.2 3.2v28H59.6V97h3c3.8 0 7.6-1.4 10.5-4l2-1.8 2 1.8c2.9 2.6 6.6 4 10.5 4s7.6-1.4 10.5-4l2-1.8 2 1.8c2.9 2.6 6.6 4 10.5 4s7.6-1.4 10.5-4l2-1.8 2 1.8c2.9 2.6 6.6 4 10.5 4h3z",
    style: {
      fill: "#202425"
    }
  }));
};
export default SvgStore;